import styled, { css } from "styled-components";
import { Colors } from "styles/Colors";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    height: 100%;
    font-family: ${({ theme }) => theme.fontFamily};
`;
export const TopText = styled.p`
    color: ${({ theme }) => theme.textColor.dark};
    margin-bottom: 0.2rem;
    min-height: 1.25rem;
`;
export const BottomText = styled.p`
    color: ${({ theme }) => theme.textColor.dark};

    flex: 0 0 none;
    text-align: center;
    margin-top: 0.2rem;
    min-height: 1.25rem;
`;
export const StyledMatch = styled.div<{ pairingCorrect?: boolean }>`
    display: flex;
    flex-direction: column;
    background: ${Colors.panel};
    border: 1px solid
        ${({ pairingCorrect }: any) =>
            pairingCorrect ? Colors.green : Colors.body};
    border-radius: 6px;
    overflow: hidden;
    transition: border-color 0.15s ease;
    &:hover {
        border-color: ${Colors.pickstop};
    }
`;

export const Team = styled.div`
    flex: 1 1 auto;
    min-width: 0;
    padding-left: 4px;
    font-size: 13px;
    cursor: default;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
`;

export const LogoImage = styled.img`
    width: 22px;
    height: 22px;
    margin-right: 8px;
    flex: 0 0 auto;
    object-fit: contain;
    pointer-events: none;
    user-select: none;
    -webkit-user-drag: none;
`;

interface ScoreProps {
    won?: boolean;
}
export const Score = styled.div<ScoreProps>`
    flex: 0 0 auto;
    margin-left: 8px;
    min-width: 20px;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 13px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
`;
interface SideProps {
    won?: boolean;
    hovered?: boolean;
    correctParticipant?: boolean;
    correctPlacement?: boolean;
    loserQualifies?: boolean;
}
export const Side = styled.div<SideProps>`
    display: flex;
    height: 36px;
    align-items: center;
    padding: 0 8px 0 13px;

    border-left: 3px solid
        ${({ theme, won, correctParticipant }: any) =>
            correctParticipant
                ? Colors.green
                : won
                ? theme.border.highlightedColor
                : "transparent"};

    background: ${({ theme, won, correctParticipant }: any) => {
        const base = won
            ? theme.matchBackground.wonColor
            : theme.matchBackground.lostColor;
        return correctParticipant
            ? `linear-gradient(90deg, rgba(120, 222, 126, 0.34), rgba(120, 222, 126, 0) 15%), ${base}`
            : base;
    }};

    margin: ${({ loserQualifies }: any) =>
        loserQualifies ? "16px 0px 0px 0px" : "0px"};

    ${Team} {
        color: ${({ theme, won, correctParticipant }: any) =>
            won || correctParticipant
                ? theme.textColor.winner
                : theme.textColor.dark};
        font-weight: ${({ won, correctParticipant }: any) =>
            won || correctParticipant ? 500 : 400};
    }
    ${Score} {
        background: ${({ theme, won }: any) =>
            won
                ? theme.score.background.wonColor
                : theme.score.background.lostColor};
        color: ${({ theme, won }: any) =>
            won ? theme.score.text.winner : theme.textColor.dark};
        font-weight: ${({ won }: any) => (won ? 600 : 400)};
    }
    ${({ hovered }: any) =>
        hovered &&
        css`
            ${Team} {
                color: ${Colors.pickstop};
            }
        `}
    ${({ highlighted }: any) =>
        highlighted &&
        css`
            ${Team} {
                color: ${Colors.pickstop};
            }
        `}
`;
interface LineProps {
    highlighted?: boolean;
}
export const Line = styled.div<LineProps>`
    height: 1px;
    transition: background-color 0.3s
        ${({ theme }) => theme.transitionTimingFunction};
    background: ${({ highlighted, theme }: any) =>
        highlighted ? theme.border.highlightedColor : Colors.body};
`;

export const Anchor = styled.a`
    font-family: ${(props: any) =>
        props.font ? props.font : props.theme.fontFamily};
    font-weight: ${(props: any) => (props.bold ? "700" : "400")};
    color: ${(props: any) => props.theme.textColor.main};
    font-size: ${(props: any) => (props.size ? props.size : "1rem")};
    line-height: 1.375rem;
    text-decoration: none;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;
